'use client'

import styled from 'styled-components'

import { TypeStyle } from '@syconium/little-miss-figgy'

export const Body = styled.div`
  border-top: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.background};
  line-height: 18px;
  padding: ${o => o.theme.spacing(5, 0, 3, 0)};

  &:first-of-type {
    border-top-width: 0;
  }
`

export const Details = styled.div`
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  padding: ${o => o.theme.spacing(0, 0, 5)};
`

export const Title = styled(TypeStyle.HeadlineExtraExtraSmall)``

export const PriceSection = styled.div`
  align-items: flex-start;
  display: flex;
`

export const Items = styled.div`
  border-left: 4px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.background};
`

export const QuantityWrapper = styled.div`
  display: inline-block;
  padding: ${o => o.theme.spacing(0, 0, 2.5, 0)};
`

export const SiteWidePromoWrap = styled(TypeStyle.BodyNano)`
  color: ${o => o.theme.color.stroke.critical.text.on.background};
  padding-bottom: ${o => o.theme.spacing(5)};
  font-weight: 600;
  text-transform: uppercase;
`
